<template>
  <div id="app">
    <popup-exit-window
      id="popup"
      class="animated fadeIn"
      style="animation-duration: .4s !important;"
    />

    <loader
      class="animated"
      :class="finishLoad"
      style="animation-duration: .4s !important;"
      v-if="(this.$route.path === '/' || this.$route.path === '/vender-meu-carro')"
    />

    <header class="w-100">
      <!-- headers -->
      <section class="position-absolute w-100" style="z-index: 2;">
        <purple-header />
        <yellow-header />
      </section>
    </header>

    <section class="container-site">
      <!-- content -->
      <router-view :busTopSpace="fixTopSpace" />

      <!-- footer -->
      <my-footer />
    </section>

    <!-- progress bar -->
    <vue-progress-bar />

    <!-- global button -->
    <global-button />

    <!-- zap icon -->
    <zap />
  </div>
</template>

<script>
// all
import PurpleHeader from "@/components/PurpleHeader";
import YellowHeader from "@/components/YellowHeader";
import Zap from "@/components/Zap";
import Loader from "@/components/Loader";
import GlobalButton from "@/components/GlobalButton";
import Popup from "@/components/Popup";
import Footer from "@/components/Footer";

export default {
  data: () => {
    return {
      fixTopSpace: "padding: 100px 0px;",
      finishLoad: ""
    };
  },
  components: {
    "purple-header": PurpleHeader,
    "yellow-header": YellowHeader,
    zap: Zap,
    loader: Loader,
    "global-button": GlobalButton,
    "popup-exit-window": Popup,
    "my-footer": Footer
  },
  mounted() {
    this.$Progress.finish();
    setTimeout(() => {
      this.finishLoad = "fadeOut";
      setTimeout(() => {
        this.finishLoad = this.finishLoad + " d-none";
      }, 500);
    }, 1000);
  },
  created() {
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
    });
  }
};
</script>

<style lang="scss">
@import "./scss/animate.css/animate.scss";
@import "./fonts/roboto/roboto.scss";
@import "./fonts/tt-supermolot/tt-supermolot.scss"; // import secondary font

// fontname by var
$font-family-primary: "Roboto", sans-serif;
$font-family-secondary: "TT Supermolot";

// fonts by class
.font-family-primary {
  font-family: #{$font-family-primary} !important;
}
.font-family-secondary {
  font-family: #{$font-family-secondary} !important;
}

body {
  @extend .font-family-primary;
  overflow-x: hidden;
}

.float-box {
  z-index: 10 !important;
}

.box-backdrop {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5 !important;
}

.fix-header {
  padding: 100px 0px;

  @media screen and (max-width: 793px) {
    padding: 0px;
  }
}

.container-site {
  position: absolute;
  top: 40px;
  width: 100%;
}

.border-top-white {
  border-top: 2px solid #fff;
  @media screen and (max-width: 768px) {
    border: 0px;
  }
}

.border-top-purple {
  border-top: 2px solid rgba(67, 0, 108, 1);
  @media screen and (max-width: 768px) {
    border: 0px;
  }
}

.border-left-yellow {
  border-left: 2px solid rgba(243, 211, 79, 1) !important;
}

.border-left-purple {
  border-left: 3px solid rgba(67, 0, 108, 1) !important;
}

.border-left-mustard {
  border-left: 3px solid rgba(223, 163, 65, 1) !important;
}

.shadow-lg-reverse {
  box-shadow: -3rem 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

#mask {
  animation: mask 975ms ease infinite;
}
@keyframes mask {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(280px);
  }
}
</style>
